import ListTableFileType from './list-table-file-type'
import ListTableFileSize from './list-table-file-size'

import { ordinaryFileTypeArray } from '@/utils/ordinary-file-type-map.js'

export default {
  picture: {
    title: '图片',
    icon: {
      show: false,
      message: ''
    },
    name: 'picture',
    component: '',
    showButton: true,
    mode: 'image',
    form: {
      radio: {
        label: '资料类型',
        show: true,
        data: [{
          label: '图片',
          name: 'picture'
        }, {
          label: '视频',
          name: 'ordinaryVideo'
        }, {
          label: '文件',
          name: 'file'
        }]
      },
      input: {
        show: true,
        placeholder: '请输入标题'
      }
    },
    params: {
      type: 'picture'
    },
    // 数量限制
    limit: 9
  },
  ordinaryVideo: {
    title: '视频',
    icon: {
      show: false,
      message: ''
    },
    name: 'ordinaryVideo',
    component: '',
    showButton: true,
    mode: 'image',
    modeType: 'video',
    form: {
      radio: {
        label: '资料类型',
        show: true,
        data: [{
          label: '图片',
          name: 'picture'
        }, {
          label: '视频',
          name: 'ordinaryVideo'
        }, {
          label: '文件',
          name: 'file'
        }]
      },
      input: {
        show: true,
        placeholder: '请输入标题'
      }
    },
    params: {
      type: 'ordinaryVideo'
    },
    limit: 3
  },
  file: {
    title: '文件',
    icon: {
      show: true,
      message: '小程序暂不支持TXT格式'
    },
    name: 'file',
    component: '',
    showButton: true,
    mode: 'table',
    form: {
      radio: {
        label: '资料类型',
        show: true,
        data: [{
          label: '图片',
          name: 'picture'
        }, {
          label: '视频',
          name: 'ordinaryVideo'
        }, {
          label: '文件',
          name: 'file'
        }]
      },
      select: {
        placeholder: '文件类型',
        data: ordinaryFileTypeArray
      },
      input: {
        show: true,
        placeholder: '请输入标题'
      }
    },
    list: {
      type: 'Table', // or Image
      columns: [
        {
          selection: true,
          idKey: 'id'
        },
        {
          prop: 'title',
          label: '文件名称',
          showOverflowTooltip: true
        },
        {
          prop: 'fileType',
          label: '类型',
          component: ListTableFileType
        },
        {
          prop: 'size',
          label: '大小',
          component: ListTableFileSize
        },
        {
          prop: 'createTime',
          label: '上传日期'
        }
      ]
    },
    params: {
      type: 'file'
    },
    limit: 9
  }

}
